export var DiscountType;
(function (DiscountType) {
    DiscountType["Percentage"] = "PERCENTAGE";
    DiscountType["Fix"] = "FIX";
})(DiscountType || (DiscountType = {}));
export var SpecialOfferSubject;
(function (SpecialOfferSubject) {
    SpecialOfferSubject["Container"] = "special-offer-container";
})(SpecialOfferSubject || (SpecialOfferSubject = {}));
//# sourceMappingURL=coupons.enum.js.map